// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets-kios/css/animate.css
// module id = 1530
// module chunks = 173